import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import balanceUploadServices from '@src/services/balanceUpload.services';
import { getLoadBalanceDetailsGetPagedList } from './balanceUploadDetailSlice';
import dayjs from '@src/utils/day';
import cardOrderServices from '@src/services/cardOrder.services';
import mobilExpressServices from '@src/services/mobilExpress.services';
import { VouIdCode } from '../enums';
import { setIsSchool } from './authSlice';

export const getCurrentLoadBalanceOnlyBalance = createAsyncThunk(
  'getCurrentLoadBalanceOnlyBalance',
  async (body, { getState, dispatch, rejectWithValue }) => {
    try {
      const customer = await getState().customer;
      const customerId = customer?.selectedCustomer?.customerId;
      const data = await balanceUploadServices.getCurrentLoadBalance({
        customerId,
        vouId: body?.vouId ?? 1,
      });
      return data?.data;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const cardOrderGetOrderCalculateAmountGetList = async (
  customerId,
  vouId,
  orderTypeId,
  paymentReferenceType,
  id,
) => {
  return await cardOrderServices.getOrderCalculateAmountGetList({
    customerId,
    vouId,
    orderTypeId,
    paymentReferenceType,
    id,
  });
};
export const getCurrentLoadBalance = createAsyncThunk(
  'getCurrentLoadBalance',
  async (body, { getState, dispatch, rejectWithValue }) => {
    try {
      const customer = await getState().customer;
      const customerId = customer?.selectedCustomer?.customerId;
      let res = await balanceUploadServices.getCurrentLoadBalance({
        customerId,
        vouId: body?.vouId ?? 1,
      });
      const getOrderCalculateAmountGetList = await cardOrderGetOrderCalculateAmountGetList(
        customerId,
        res.data.vouId,
        res.data.orderType,
        2,
        res.data.id,
      );
      if (getOrderCalculateAmountGetList?.data?.length > 0) {
        res.data.totalPaymentAmount = getOrderCalculateAmountGetList?.data[0].totalPaymentAmount;
      } else {
        res.data.totalPaymentAmount = 0;
      }
      return res;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getBalanceUploadById = createAsyncThunk(
  'getBalanceUploadById',
  async (id, { getState, dispatch, rejectWithValue }) => {
    try {
      return await balanceUploadServices.getById({ id });
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getById = createAsyncThunk(
  'getById',
  async (id, { getState, dispatch, rejectWithValue }) => {
    try {
      const customer = await getState().customer;
      const customerId = customer?.selectedCustomer?.customerId;
      if (isNaN(+id)) {
        return null;
      }
      const res = await balanceUploadServices.getById({ id });
      const getOrderCalculateAmountGetList = await cardOrderGetOrderCalculateAmountGetList(
        customerId,
        res.data.vouId,
        res.data.orderType,
        2,
        id,
      );
      if (getOrderCalculateAmountGetList?.data?.length > 0) {
        res.data.totalPaymentAmount = getOrderCalculateAmountGetList?.data[0].totalPaymentAmount;
      } else {
        res.data.totalPaymentAmount = 0;
      }
      return res;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getBusinessDayByMonth = createAsyncThunk(
  'getBusinessDayByMonth',
  async (monthId, { rejectWithValue }) => {
    try {
      const res = await balanceUploadServices.getBusinessDayByMonth({ monthId });
      return res;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getPreviousLoadBalance = createAsyncThunk(
  'getPreviousLoadBalance',
  async (body, { getState, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      if (!customerId) {
        return rejectWithValue({
          message: 'Lütfen anasayfaya giderek müşteri tipi seçiniz.',
        });
      }
      return await balanceUploadServices.getPreviousLoadBalance({
        customerId,
        integrationId: body?.integrationId,
      });
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getDraftedLoadBalances = createAsyncThunk(
  'getDraftedLoadBalances',
  async ({ pageNumber, pageSize }, { getState, dispatch, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      if (!customerId) {
        return rejectWithValue({
          message: 'Lütfen anasayfaya giderek müşteri tipi seçiniz.',
        });
      }

      const action = await balanceUploadServices.getDraftedLoadBalances({
        customerId,
        pageNumber,
        pageSize,
      });
      return action;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const prepareLoadBalance = createAsyncThunk(
  'prepareLoadBalance',
  async (body, { getState, dispatch, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      if (!customerId) {
        return rejectWithValue({
          message: 'Lütfen anasayfaya giderek müşteri tipi seçiniz.',
        });
      }
      delete body.totalPaymentAmount;
      const res = await balanceUploadServices.prepareLoadBalance({ ...body, customerId });
      if (body.vouId !== 94 && res?.data?.id && body.orderProcessType !== 3) {
        await dispatch(
          getLoadBalanceDetailsGetPagedList({
            body: { loadBalanceId: res?.data?.id, vouId: body?.vouId ?? 1 },
          }),
        );
      }
      const getOrderCalculateAmountGetList = await cardOrderGetOrderCalculateAmountGetList(
        customerId,
        res.data.vouId,
        res.data.orderType,
        2,
        res.data.id,
      );
      if (getOrderCalculateAmountGetList?.data?.length > 0) {
        res.data.totalPaymentAmount = getOrderCalculateAmountGetList?.data[0].totalPaymentAmount;
      } else {
        res.data.totalPaymentAmount = 0;
      }
      return res;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const loadBalancesSave = createAsyncThunk(
  'loadBalancesSave',
  async (body, { getState, rejectWithValue }) => {
    try {
      const customer = await getState()?.customer;
      const customerId = customer?.selectedCustomer?.customerId;
      delete body.totalPaymentAmount;
      const res = await balanceUploadServices.loadBalancesSave({ entity: { ...body, customerId } });
      const getOrderCalculateAmountGetList = await cardOrderGetOrderCalculateAmountGetList(
        customerId,
        res.data.vouId,
        res.data.orderType,
        2,
        res.data.id,
      );
      if (getOrderCalculateAmountGetList?.data?.length > 0) {
        res.data.totalPaymentAmount = getOrderCalculateAmountGetList?.data[0].totalPaymentAmount;
      } else {
        res.data.totalPaymentAmount = 0;
      }
      return res;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const loadBalancesUpdate = createAsyncThunk(
  'loadBalancesUpdate',
  async (body, { getState, rejectWithValue, dispatch }) => {
    try {
      const customer = await getState().customer;
      const customerId = customer?.selectedCustomer?.customerId;
      if (!body?.id) {
        return rejectWithValue({
          message: 'Kayıt bulunamadı.',
        });
      }
      delete body.totalPaymentAmount;
      const isSendMail = !(!body.sendMail || body.sendMail === false);
      delete body.sendMail;

      if (body.orderStatus === 90 && !body.cardBin) {
        const { selectedStoredCard } = (await getState()).mobilExpress;
        if (selectedStoredCard) {
          const cards =
            (
              await mobilExpressServices.storedCardGetAll({
                customerId: body.customerId,
                VouId: body.vouId ?? 1,
              })
            )?.data?.cardList || [];
          body.cardToken = selectedStoredCard;
          const cardBin =
            cards
              .find((card) => card.cardToken === selectedStoredCard)
              ?.maskedCardNumber?.slice(0, 6) || '';
          if (cardBin) {
            body.cardBin = cardBin;
          }
        }
      }
      if (body.cardBin === '') {
        body.cardBin = null;
      }

      if (body.dontSendBinAndToken) {
        body.cardBin = null;
        body.cardToken = null;
      }

      const res = await balanceUploadServices.loadBalancesUpdate({
        entity: { ...body, customerId },
        sendMail: isSendMail,
      });
      dispatch(setIsSchool(res.data?.isSchool));
      const getOrderCalculateAmountGetList = await cardOrderGetOrderCalculateAmountGetList(
        customerId,
        res.data.vouId,
        res.data.orderType,
        2,
        res.data.id,
      );
      if (getOrderCalculateAmountGetList?.data?.length > 0) {
        res.data.totalPaymentAmount = getOrderCalculateAmountGetList?.data[0].totalPaymentAmount;
      } else {
        res.data.totalPaymentAmount = 0;
      }
      return res;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const loadBalancesDelete = createAsyncThunk(
  'loadBalancesDelete',
  async (body, { getState, dispatch, rejectWithValue }) => {
    try {
      const currentLoadBalanceId = await getState()?.balanceUpload?.currentLoadBalance?.id;
      const id = body?.id || currentLoadBalanceId;
      const CancelledByUser = body?.CancelledByUser || false;
      const response = await balanceUploadServices.loadBalancesDelete({ id, CancelledByUser });
      await dispatch(getCurrentLoadBalance());
      return response;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const copyLoadBalance = createAsyncThunk(
  'copyLoadBalance',
  async (body, { getState, rejectWithValue }) => {
    try {
      delete body.totalPaymentAmount;
      return await balanceUploadServices.copyLoadBalance(body);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const putLoadBalanceSubType = createAsyncThunk(
  'putLoadBalanceSubType',
  async (body, { rejectWithValue }) => {
    try {
      return await balanceUploadServices.putSubTypeReport(body);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getLoadBalanceForThanksPage = createAsyncThunk(
  'getLoadBalanceForThanksPage',
  async ({ id, vouId }, { getState, rejectWithValue }) => {
    try {
      const provisionDay = await getState()?.mobilExpress?.payLaterDayForThanksPage;
      return await balanceUploadServices.getLoadBalanceForThanksPage(id, provisionDay, vouId);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getLoadBalancesForStatusWithUpdaterUserName = createAsyncThunk(
  'getLoadBalancesForStatusWithUpdaterUserName',
  async (body, { rejectWithValue }) => {
    try {
      delete body.totalPaymentAmount;
      return await balanceUploadServices.getLoadBalancesForStatusWithUpdaterUserName({
        data: body,
      });
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getOrderDoubleCheck = createAsyncThunk(
  'getOrderDoubleCheck',
  async (body, { rejectWithValue }) => {
    try {
      const res = await balanceUploadServices.getOrderDoubleCheck(body);
      return res;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const getLoadBalanceSucceeded = (state, action) => {
  state.currentLoadBalance = action?.payload?.data;
  if (action?.payload?.data?.orderStatus === 0) {
    state.activeStep = 0;
  } else if (action?.payload?.data?.orderStatus === 10 && action?.payload?.data?.isShowPopup) {
    state.activeStep = 0;
  } else if (action?.payload?.data?.orderStatus === 10) {
    state.activeStep = 1;
  } else if (action?.payload?.data?.orderStatus === 20) {
    state.activeStep = 2;
  } else if (
    action?.payload?.data?.orderStatus === 100 ||
    action?.payload?.data?.orderStatus === 90 ||
    action?.payload?.data?.orderStatus === 15
  ) {
    state.activeStep = 3;
  }

  try {
    if (state.activeStep > 0) {
      const now = new Date();
      const today = dayjs(now.toISOString());
      if (state.currentLoadBalance?.activationDate) {
        const activationDate = dayjs(state.currentLoadBalance.activationDate);
        const isBefore = activationDate.isBefore(today, 'day');
        if (isBefore) {
          state.currentLoadBalance.activationDate = today.format('YYYY-MM-DDTHH:mm:ss');
        }
      }
    }
  } catch (e) { }
};

const initialState = {
  activeStep: 0,
  currentLoadBalance: {},
  isMaxValuePopupOpen: false,
  draftedLoadBalances: [],
  loadBalanceList: [],
  draftedTableProperty: {
    currentPage: 1,
    page: 1,
    pageSize: 10,
    totalCount: 0,
  },
  thanksPageBalanceUploadTextList: {},
  selectedRowKeys: [],
  isAllSelectedRowKeys: false,
  latestLoadBalanceFetchId: null,
  runTimeTotalPrice: 0,
  excelLoadBalanceList: {
    templateStep: 0,
    orderStep: null,
    isSuccess: false,
    hasNoError: false,
  },
  orderDoubleCheck: {},
  getWorkingDays: {},
  daysStatus: {
    includeSaturday: false,
    includeSunday: false,
    includeHoliday: false,
    includeWeekdays: true,
  },
  currentMonthDayCount: 0,
};

export const balanceUploadSlice = createSlice({
  name: 'balanceUpload',
  initialState,
  reducers: {
    setActiveStep: (state, action) => {
      state.activeStep = action.payload;
    },
    nextStep: (state) => {
      state.activeStep = state.activeStep + 1;
    },
    prevStep: (state) => {
      state.activeStep = state.activeStep - 1;
    },
    setTemplateStep: (state, action) => {
      state.excelLoadBalanceList.templateStep = action.payload;
    },
    setOrderStep: (state, action) => {
      state.excelLoadBalanceList.orderStep = action.payload;
    },
    setExcelSuccess: (state, action) => {
      state.excelLoadBalanceList.isSuccess = action.payload;
    },
    setExcelNoError: (state, action) => {
      state.excelLoadBalanceList.hasNoError = action.payload;
    },
    setCurrentLoadBalance: (state, action) => {
      state.currentLoadBalance = {
        ...state.currentLoadBalance,
        ...action.payload,
      };
    },
    resetCurrentLoadBalance: (state) => {
      //state.currentLoadBalance = {}
      return initialState;
    },
    setRunTimeTotalPrice: (state, action) => {
      state.runTimeTotalPrice = action.payload;
    },
    setSelectedRowKeys: (state, action) => {
      state.selectedRowKeys = action.payload;
    },
    setIsAllSelectedRowKeys: (state, action) => {
      state.isAllSelectedRowKeys = action.payload;
    },
    setCurrentMonthDayCount: (state, action) => {
      state.currentMonthDayCount = action.payload;
    },
    setDaysStatus: (state, action) => {
      state.daysStatus = { ...state.daysStatus, ...action.payload };
    },
    setIsMaxValuePopupOpen: (state, action) => {
      state.isMaxValuePopupOpen = action.payload;
    },
  },
  extraReducers: (builder) => {
    const trackLoadBalanceFetch = (state, action) => {
      state.latestLoadBalanceFetchId = action.meta.requestId;
    };
    // An outdated getById/getBalanceUploadById response must not overwrite a newer total price.
    const applyLatestLoadBalanceFetch = (state, action) => {
      if (state.latestLoadBalanceFetchId && action.meta.requestId !== state.latestLoadBalanceFetchId) {
        return;
      }
      getLoadBalanceSucceeded(state, action);
    };
    builder.addCase(getBalanceUploadById.pending, trackLoadBalanceFetch);
    builder.addCase(getById.pending, trackLoadBalanceFetch);
    builder.addCase(getBalanceUploadById.fulfilled, applyLatestLoadBalanceFetch);
    builder.addCase(getById.fulfilled, applyLatestLoadBalanceFetch);
    builder.addCase(getCurrentLoadBalance.fulfilled, (state, action) => {
      getLoadBalanceSucceeded(state, action);
    });
    builder.addCase(loadBalancesUpdate.fulfilled, (state, action) => {
      getLoadBalanceSucceeded(state, action);
    });
    builder.addCase(loadBalancesSave.fulfilled, (state, action) => {
      getLoadBalanceSucceeded(state, action);
    });
    builder.addCase(getPreviousLoadBalance.fulfilled, (state, action) => {
      state.currentLoadBalance = action?.payload?.data;
      state.activeStep = 0;
    });
    builder.addCase(getDraftedLoadBalances.fulfilled, (state, action) => {
      state.draftedLoadBalances = action?.payload?.data?.items || [];
      state.draftedTableProperty = action?.payload?.data?.pagedProperty || {};
    });
    builder.addCase(getDraftedLoadBalances.rejected, (state, action) => {
      state.draftedLoadBalances = [];
      state.draftedTableProperty = {
        currentPage: 1,
        page: 1,
        pageSize: 10,
        totalCount: 0,
      };
    });
    builder.addCase(prepareLoadBalance.fulfilled, (state, action) => {
      state.currentLoadBalance = action?.payload?.data;
      state.activeStep = 0;
    });
    builder.addCase(getLoadBalanceForThanksPage.fulfilled, (state, action) => {
      state.thanksPageBalanceUploadTextList = action?.payload?.data;
    });
    builder.addCase(getLoadBalancesForStatusWithUpdaterUserName.fulfilled, (state, action) => {
      state.loadBalanceList = action?.payload?.data?.items || [];
      state.draftedTableProperty = action?.payload?.data?.pagedProperty || {};
    });
    builder.addCase(getLoadBalancesForStatusWithUpdaterUserName.rejected, (state, action) => {
      state.loadBalanceList = [];
      state.draftedTableProperty = {
        currentPage: 1,
        page: 1,
        pageSize: 10,
        totalCount: 0,
      };
    });
    builder.addCase(getOrderDoubleCheck.fulfilled, (state, action) => {
      state.orderDoubleCheck = action?.payload?.data;
    });
    builder.addCase(getBusinessDayByMonth.fulfilled, (state, action) => {
      state.getWorkingDays = action.payload.data;
      const {
        workDays = 0,
        saturday = 0,
        sunday = 0,
        publicHoliday = 0,
        bairam = 0,
      } = state.getWorkingDays || {};
      state.currentMonthDayCount = workDays + saturday + sunday + publicHoliday + bairam;
    });
  },
});

export const {
  nextStep,
  prevStep,
  setCurrentLoadBalance,
  setActiveStep,
  setTemplateStep,
  setOrderStep,
  setExcelSuccess,
  resetCurrentLoadBalance,
  setRunTimeTotalPrice,
  setSelectedRowKeys,
  setIsAllSelectedRowKeys,
  setExcelNoError,
  setCurrentMonthDayCount,
  setDaysStatus,
  setIsMaxValuePopupOpen,
} = balanceUploadSlice.actions;
